/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useEditStock, useGetStock } from "../../services/stock";
import {
  useLookupCustomers,
  useLookupMachineMakers,
  useLookupCashCenters,
  useLookupCurrencyMultiples,
} from "../../services/lookups-mutations";
import { useLookupCurrency } from "../../services/lookups-queries";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormInput from "../../components/forms/form-Input";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import { CASSETTES_TYPES, DEFAULT_STOCK } from "./constants";

export default function EditStock() {
  const [stock, setStock] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const {
    mutate: getCustomers,
    data: customerListRes,
    isPending: gettingCustomerList,
    // error: customerListError,
  } = useLookupCustomers();

  const {
    mutate: getMakersList,
    data: makersListRes,
    isPending: gettingMakersList,
    // error: makersListError,
  } = useLookupMachineMakers();
  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();
  const {
    data: currencyListRes,
    isPending: gettingCurrencyList,
    // error: currencyError,
  } = useLookupCurrency();
  const {
    mutate: getMultiples,
    data: multipleList,
    // isPending: gettingMultiples,
    // error: multipleError,
    reset: multipleReset,
  } = useLookupCurrencyMultiples();
  const {
    mutate: createRequest,
    data: createRequestResponse,
    isPending: creatingRequest,
  } = useEditStock();
  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: gettingDetails,
    // error: detailsError,
    reset: detailsReset,
  } = useGetStock();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { ...DEFAULT_STOCK },
  });
  useEffect(() => {
    getCustomers();
    getCashCenter();
    getMakersList();
    if (params.stockId) {
      getDetails(params.stockId);
    }
  }, []);
  useEffect(() => {
    if (createRequestResponse) {
      navigate(Paths.stock);
    }

    if (detailsRes && currencyListRes) {
      const _res = detailsRes.data;
      setStock({ ..._res });
      const _details = {
        cashCenterId: _res.cashCenterId
          ? { cashCenterId: _res.cashCenterId, name: _res.cashCenter }
          : "",
        customerId: _res.customerId
          ? { customerId: _res.customerId, name: _res.customer }
          : "",
        description: _res.description,
        currency: _res.denomination
          ? currencyListRes.data.find(
              (elm) => elm.shortName === _res.denomination.split(" ")[0]
            )
          : "",
        multiple: _res.denomination
          ? {
              id: Number(_res.denomination.split(" ")[1]),
              text: Number(_res.denomination.split(" ")[1]),
            }
          : "",
        cassetteType: { id: _res.cassetteType, text: _res.cassetteType },
        maker: { name: _res.maker },
        limit: _res.limit,
        topSerialNo: _res.topSerialNo,
        bottomSerialNo: _res.bottomSerialNo,
      };
      reset({ ..._details });
      detailsReset();
    }
  }, [
    createRequestResponse,

    detailsRes,
    customerListRes,
    currencyListRes,
    cashCenterList,
  ]);

  const formValidationRules = {
    cashCenterId: { required: "Please select cash center" },
    customerId: { required: "Please select customer" },
    description: { required: "Please add description" },
    currency: { required: "Please select currency" },
    multiple: { required: "Please select multiple" },
    cassetteType: { required: "Please select cassette type" },
    maker: { required: "Please select maker" },
    topSerialNo: { required: "Please add top serial no" },
  };
  const generalFieldProps = { errors, control };
  const onCurrencyChange = (e) => {
    multipleReset();
    if (e.target.value.shortName !== "0") {
      getMultiples(e.target.value.shortName);
    }
  };
  const onSubmit = (data) => {
    const _payload = {
      id: stock.id || stock.stockId,
      cashCenterId: data.cashCenterId?.cashCenterId || "",
      customerId: data.customerId?.customerId || "",
      description: data.description,
      denomination:
        data.currency && data.multiple
          ? `${data.currency.shortName} ${data.multiple.id}`
          : "",
      cassetteType: data.cassetteType?.id || "",
      maker: data.maker?.name,
      limit: !data.limit || data.limit === "0" ? 0 : data.limit,
      status: stock.status,
    };
    // console.log(_payload);
    createRequest(_payload);
  };
  return (
    <>
      {gettingCurrencyList ||
      gettingCashCenterList ||
      gettingCustomerList ||
      gettingDetails ||
      creatingRequest ||
      gettingMakersList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Stocks", link: Paths.stock },
            { text: "Edit Stock", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Heading>Edit Stock</Heading>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="add-location-form"
              >
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenterId"
                  id="cashCenterId"
                  text="name"
                  data={cashCenterList?.data || []}
                  placeholder="Select Cash Center"
                  rules={formValidationRules.cashCenterId}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Customer"
                  name="customerId"
                  id="customerId"
                  text="name"
                  data={customerListRes?.data || []}
                  placeholder="Select Customer"
                  rules={formValidationRules.customerId}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Description"
                  name="description"
                  rules={formValidationRules.description}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Currency"
                  name="currency"
                  id="shortName"
                  text="name"
                  data={currencyListRes?.data || []}
                  placeholder="Select Currency"
                  rules={formValidationRules.currency}
                  onChange={onCurrencyChange}
                  dropdownProps={{ filterable: true }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Multiple"
                  name="multiple"
                  id="id"
                  text="text"
                  data={
                    multipleList?.data.map((elm) => ({
                      id: elm.multiple,
                      text: elm.multiple,
                    })) || []
                  }
                  placeholder="Select Multiple"
                  rules={formValidationRules.multiple}
                  dropdownProps={{ filterable: true }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cassette Type"
                  name="cassetteType"
                  id="id"
                  text="text"
                  data={CASSETTES_TYPES}
                  placeholder="Select Cassette Type"
                  rules={formValidationRules.cassetteType}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Maker"
                  name="maker"
                  id="name"
                  text="name"
                  rules={formValidationRules.maker}
                  data={makersListRes?.data || []}
                  placeholder="Select Maker"
                />
                <NumericInput
                  {...generalFieldProps}
                  label="Limit"
                  name="limit"
                />

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "16px",
                  }}
                >
                  <Button type="submit">Update Stock</Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
